module.exports = __webpack_public_path__ + "static/media/step-three.fbb9a44b.svg";